
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie-management",
      function () {
        return require("private-next-pages/cookie-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookie-management"])
      });
    }
  